"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAkeyWebview = isAkeyWebview;
/**
 * Проверка на клиенте
 */
function isAkeyWebview() {
    if (typeof window !== 'undefined') {
        return Boolean(window?.akeyWebview);
    }
    return false;
}
